import { styled } from 'styled-system/jsx'

/**
 * Wrapper that themes `react-international-phone` to the QuickPass look. The
 * library reads `--react-international-phone-*` custom properties off an
 * ancestor, so setting them here cascades into its country selector + input.
 */
const PhoneFieldWrapper = styled('div', {
  base: {
    width: '100%',
    '--react-international-phone-height': '44px',
    '--react-international-phone-font-size': '15px',
    '--react-international-phone-border-radius': '10px',
    '--react-international-phone-border-color': '#E5E0F5',
    '--react-international-phone-text-color': '#1A1330',
    '--react-international-phone-country-selector-arrow-color': '#8A82A6',
    '--react-international-phone-selected-dropdown-item-background-color':
      'rgba(128, 84, 255, 0.12)',
    '--react-international-phone-country-selector-background-color-hover':
      'rgba(128, 84, 255, 0.08)',
    '& .react-international-phone-input-container': {
      width: '100%',
    },
    '& .react-international-phone-input': {
      width: '100%',
      fontFamily: 'body',
    },
    '& .react-international-phone-input:focus, & .react-international-phone-country-selector-button:focus':
      {
        outline: 'none',
        borderColor: 'quickpass.primary',
        boxShadow: '0 0 0 3px rgba(128, 84, 255, 0.18)',
      },
  },
})

export { PhoneFieldWrapper }
